import { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Icon, IconButton, LinearProgress, Pagination, Paper, Snackbar, SnackbarCloseReason, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow} from '@mui/material';
import { Environment } from '../../../shared/environment';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { AuxilioService, IListagemAuxilio } from '../../../shared/services/api/rh/Auxilio/AuxilioService';

export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  onClose: (value?: string) => void;
}

export const DialogAuxilio: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {
 
  const { onClose, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [rows, setRows] = useState<IListagemAuxilio[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);
  const idfun = useMemo(() => {
    return searchParams.get('idfun') || props.id;
  }, [searchParams]);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
  const [openConfirm, setOpenConfirm] = useState(false);
  const [ids, setIds] = useState('');
          
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
        
  const handleDelete = (id: string) => {
    setOpenConfirm(true); 
    setIds(id);
  };
        
  const handleConfirmDelete = (id: string) => {
    AuxilioService.deleteById(id)
      .then(result => {
        if (result instanceof Error) {
          setOpenConfirm(false);
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          setOpenConfirm(false);
          setTms('success');
          setMsg('Registro apagado com sucesso!');
          setOpenmsg(true);
          setIsLoading(true);
          AuxilioService.getAll(pagina, idfun)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setOpenConfirm(false);
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTotalCount(result.totalCount);
                setRows(result.data);
              }
            });
        }
      });
    setOpenConfirm(false);
  };
        
  const handleCancelDelete = () => {
    setOpenConfirm(false);
  };
 
  useEffect(() => {
    if(idfun != 'novo'){
      setIsLoading(true);
      AuxilioService.getAll(pagina, props.id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setRows(result.data);
          }
        });
    }
  }, [pagina, idfun, open]);

  const handleCancel = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      {...other}      
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Snackbar open={openConfirm} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert
          severity="warning"  
          variant="filled"
          sx={{ display: 'flex', alignItems: 'center', width: '100%' }}
          action={
            <>
              <Button color="inherit" size="small" onClick={() => {handleConfirmDelete(ids);}}>
                    Sim
              </Button>
              <Button color="inherit" size="small" onClick={handleCancelDelete}>
                    Nâo
              </Button>
            </>
          }
        >
                  Tem certeza que deseja excluir este registro?
        </Alert>
      </Snackbar>
      <DialogTitle>Histórico de Auxílio</DialogTitle>
      <DialogContent dividers>
        <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto', minWidth: 350, height: 387}}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Data Saida</TableCell>
                <TableCell>Data Retorno</TableCell>
                <TableCell>Obs.</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                <TableRow key={row.idauxilio}>
                  <TableCell>{moment(row.datainicial).format('DD/MM/YYYY')}</TableCell>
                  <TableCell>{moment(row.datafinal).format('DD/MM/YYYY')}</TableCell>
                  <TableCell>{row.obs}</TableCell>
                  <TableCell>
                    <IconButton   disabled={isLoading} color='error'  size="small" onClick={() => {handleDelete(row.idauxilio);}}>
                      <Icon>delete</Icon>
                    </IconButton>  
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
  
            {totalCount === 0 && !isLoading && (
              <caption>{Environment.LISTAGEM_VAZIA}</caption>
            )}
            <TableFooter>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={3}>
                    <LinearProgress variant='indeterminate' />
                  </TableCell>
                </TableRow>
              )}
              {(totalCount > 0 && totalCount > 5) && (
                <TableRow>
                  <TableCell colSpan={3}>
                    <Pagination
                      page={pagina}
                      count={Math.ceil(totalCount / 5)}
                      onChange={(_, newPage) => setSearchParams({ idfun, pagina: newPage.toString() }, { replace: true })}
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableFooter>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button sx={{ minWidth:'30%'  }} variant='outlined' onClick={handleCancel}>Voltar</Button>      
      </DialogActions>
    </Dialog>
    
  );
}; 